export default __webpack_public_path__ + "static/media/secureTextSharingToolsRemoteTeams.1b491aef.png";